import { render, staticRenderFns } from "./specModules.vue?vue&type=template&id=607d8500&"
import script from "./specModules.vue?vue&type=script&lang=js&"
export * from "./specModules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports